import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { deleteBulkEmailJobUserData, deleteInvalidEmailBulkEmailJobUserData, deleteSingleUserFromBulkEmailUserData, getBulkEmailTemplates, getJobUserDataForBulkEmail, getSingleEmailJob, sendBulkEmail, updateBulkEmailJob } from "../../../Http/Index";
import { EmailJobsInterface, JobStatus, QueryStatus } from "../EmailBulkMessage";
import { Box, Button, Flex, Input, Select, Table, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { Layout } from "../../../GlobalComponent/Layout/Layout";
import { BenFilterPopup } from "../../../GlobalComponent/BenFIlterPopup/BenFilterPoup";
import { handleCloseModal } from "../../BenAddressData/Action/actions";
import { MdDelete } from "react-icons/md";

interface BulkEmailTemplate {
    _id: string;
    name: string;
    description: string;
    subject: string;
    body: string;
    variables: string[];
    tags: string[];
    category: string;
    isDeleted: boolean;
    templateCategory: string;
}

export enum EmailStatus {
    Pending = 'Pending',
    Sent = 'Sent',
    Error = 'Error'
}
export interface BulkEmailJobUserData {
    _id: string;
    benId: string;
    benName: string;
    benEmail: string;
    jobId: EmailStatus;
    status: string;
    reason: string;
    dynamicValues: {
        [key: string]: any; // In case there are more dynamic keys
    };

}

export const SingleEmailJob: React.FC = () => {
    const { emailJobId } = useParams()
    const [jobUserData, setJobUserData] = useState<{
        jobData: BulkEmailJobUserData[],
        hasNextPage: boolean,
        hasPreviousPage: boolean, totalPages: number,
        page: number, limit: number, totalCount: number,
        totalSuccessCount: number, totalFailedCount: number,
        totalInvalidEmails: number
    }>()
    const [job, setJob] = useState<EmailJobsInterface>()
    const [bulkTemplates, setBulkTemplates] = useState<BulkEmailTemplate[] | []>([])
    const [selectedTemplate, setSelectedTemplate] = useState<BulkEmailTemplate>()
    const navigate = useNavigate()
    const [benFilter, setBenFilter] = useState<boolean>(false);
    const [inputVariables, setInputVariables] = useState<any>({})
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const toast = useToast()
    // const [messageTo, setMessageTo] = useState<string>("All")
    const [isEditVars, setIsEditVars] = useState<boolean>(false)
    const [isPaginationLoading, setIsPaginationLoading] = useState<boolean>(false)
    const [pageLimit, setPageLimit] = useState<number>(10)
    const [companyId, setCompanyId] = useState<string>("")

    useEffect(() => {
        (async () => { getSingleJob() })();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (job?.jobStatus === JobStatus.Completed) {
            getBulkTemplates()
        }
        // eslint-disable-next-line
    }, [jobUserData])

    useEffect(() => {
        if (job?.jobStatus === JobStatus.Completed) {
            let template = bulkTemplates.find((item) => item._id === job?.templateId)
            setSelectedTemplate(template)
        }
        // eslint-disable-next-line
    }, [bulkTemplates])

    const getSingleJob = async () => {
        try {
            if (emailJobId) {
                let response = await getSingleEmailJob(emailJobId)
                const bulkJobUserData = await getJobUserDataForBulkEmail(emailJobId, 1, pageLimit)
                setJob(response.data)
                setJobUserData(bulkJobUserData.data)
                if (response?.data?.companyId) {
                    setCompanyId(response?.data?.companyId)

                }
                if (response.data.templateId) {
                    const temp = await getBulkEmailTemplates()
                    const filteredTemp = temp.data.find((item: any) => item._id === response.data.templateId)
                    setSelectedTemplate(filteredTemp)
                    setBulkTemplates(temp.data)
                    setInputVariables(response.data?.emailVars || {})
                }
            } else {
                alert("Invalid JobId")
                navigate("/bulk_email")
            }
        } catch (error: any) {
            console.log(error)
            if (error?.response?.data?.statusCode === 404 || 400) {
                alert("Invalid JobId")
            } else {
                alert(error?.response?.data?.message)
            }
            navigate("/bulk_email")
        }
    }

    const getBulkTemplates = async () => {
        if (bulkTemplates?.length <= 0) {
            try {
                let response = await getBulkEmailTemplates()
                setBulkTemplates(response.data)
            } catch (error) {
                console.log(error)
                alert("Error while getting Templates")
            }
        } else {
            return
        }
    }

    const handleTemplateInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let temp = bulkTemplates.filter((item) => item._id === e.target.value)
        setSelectedTemplate(temp[0])
    }

    // const handleMessageToInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //     setMessageTo(e.target.value)
    // }

    const handleFilterModal = () => {
        setBenFilter(!benFilter);
    };

    const deleteJobBen = async (benId: string) => {
        try {
            setIsLoading(true)
            await deleteSingleUserFromBulkEmailUserData(emailJobId!, benId)
        } catch (error: any) {
            alert(error?.response?.data?.message)
        } finally {
            handlePagination(jobUserData?.page || 1, pageLimit)
            setIsLoading(false)
        }
    }

    const sendEmail = async (e: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true)
        // const emailTo = (e.currentTarget as HTMLButtonElement).value;
        try {
            if (job?.templateId && emailJobId && selectedTemplate) {
                const temp = bulkTemplates.find((item) => item._id === job.templateId)
                if (!temp) {
                    alert("Template not saved")
                    return
                }

                if (!jobUserData || jobUserData.totalCount <= 0) {
                    alert("No Job user data present")
                    return
                }

                if (selectedTemplate?.variables?.length && selectedTemplate?.variables?.includes("customField") && !inputVariables["customField"]) {
                    alert("Please Provide Custom Field")
                    return
                }

                await sendBulkEmail(emailJobId!)
                toast({
                    title: 'Sending Email Is In Progress',
                    description: "Please refresh the page after some time if loading takes time",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                    position: "top"
                })
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                alert("Please Select Email Template")
            }
            setIsLoading(false)
        } catch (error: any) {
            alert(error?.response?.data?.message)
            setIsLoading(false)
            toast({
                title: 'Request Failed',
                description: "Please try again.",
                status: 'error',
                duration: 9000,
                isClosable: true,
                position: "top"
            })
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }

    }


    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputVariables((prev: object) => { return { ...prev, [e.target.name]: e.target.value } })
    }

    const deleteAllBenFromJob = async () => {
        setIsLoading(true)
        try {
            await deleteBulkEmailJobUserData(emailJobId!)
        } catch (error: any) {
            alert(error?.response?.data?.message)
        }
        finally {
            handlePagination(1, pageLimit)
            setIsLoading(false)
        }
    }

    const saveBasicJobData = async () => {
        try {
            setIsLoading(true)
            if (!selectedTemplate) {
                alert("Please select a template")
                return
            }

            if (selectedTemplate?.variables?.length && selectedTemplate?.variables?.includes("customField") && !inputVariables["customField"]) {
                alert("Please Provide Custom Field")
                return
            }

            let response = await updateBulkEmailJob(emailJobId!, { templateName: selectedTemplate?.name, templateId: selectedTemplate?._id, emailVars: inputVariables })
            setJob(response.data)
            setIsEditVars(false)
        } catch (error: any) {
            alert(error?.response?.data?.message)
        } finally {
            setIsLoading(false)
        }
    }

    const handlePagination = async (page: number, limit: number) => {
        try {
            setIsPaginationLoading(true)
            const response = await getJobUserDataForBulkEmail(emailJobId!, page, limit)
            setJobUserData(response.data)
        } catch (error: any) {
            alert(error?.response?.data?.message)
        }
        finally {
            setIsPaginationLoading(false)
        }
    }

    const handlePageLimit = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setPageLimit(Number(e.target.value))
        handlePagination(1, Number(e.target.value))
    }

    const checkEmailValidity = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const clearInvalidEmailBens = async () => {
        try {
            setIsLoading(true)
            await deleteInvalidEmailBulkEmailJobUserData(emailJobId!)
        } catch (error: any) {
            alert(error?.response?.data?.message)
        } finally {
            handlePagination(1, pageLimit)
            setIsLoading(false)
        }
    }

    const handleDiscard = () => {
        setIsEditVars(!isEditVars)
        if (isEditVars) {
            window.location.reload()
        }
    }

    return (
        <Layout>
            <Box width={"95%"} margin={"auto"} >
                <Flex width={"fit-content"} padding={"10px"} borderRadius={"10px"} gap={"20px"}>
                    <Text fontWeight={"bold"}>Job_Name: {job?.jobName || "N/A"}</Text>
                    <Text color={"blue"} fontWeight={"bold"}>Total Emails: {jobUserData?.totalCount}</Text>
                    <Text color={"green"} fontWeight={"bold"}>Sent Emails: {jobUserData?.totalSuccessCount}</Text>
                    <Text color={jobUserData && jobUserData.totalFailedCount > 0 ? "red" : "green"} fontWeight={"bold"}>Failed Emails: {jobUserData?.totalFailedCount}</Text>
                    <Text color={jobUserData && jobUserData?.totalInvalidEmails > 0 ? "red" : "green"} fontWeight={"bold"}>Invalid Emails: {jobUserData?.totalInvalidEmails}</Text>
                    <Text fontWeight={"bold"} color={((jobUserData?.totalCount || 0) - ((jobUserData?.totalSuccessCount || 0) + (jobUserData?.totalFailedCount || 0))) > 0 ? "orange" : "green"}>Pending Emails: {(jobUserData?.totalCount || 0) - ((jobUserData?.totalSuccessCount || 0) + (jobUserData?.totalFailedCount || 0))}</Text>
                </Flex>
                <Flex gap={"20px"} mt={"30px"} justifyContent={"center"} alignItems={"center"}>

                    {job?.jobStatus !== "Completed" && <Select value={selectedTemplate?._id} placeholder="Select Template" onClick={getBulkTemplates} width={"fit-content"} onChange={handleTemplateInput} isDisabled={(!isEditVars)} >
                        {bulkTemplates?.length > 0 && bulkTemplates.map((item) =>
                            <option value={item._id} key={item._id}> {item.name}</option>
                        )}
                    </Select>}
                    {job?.jobStatus === "Completed" && selectedTemplate && <Select width={"fit-content"} onChange={handleTemplateInput} isDisabled={job?.jobStatus === "Completed"}>
                        <option value={selectedTemplate._id} key={selectedTemplate._id}> {selectedTemplate.name}</option>
                    </Select>}
                    {selectedTemplate?.variables?.includes('customField') &&
                        <Flex gap={"20px"} justifyContent={"center"} alignItems={"center"}>
                            <Box>
                                <label>Custom Field: </label>
                                <Input
                                    isDisabled={!isEditVars}
                                    name={"customField"}
                                    maxWidth={"fit-content"}
                                    value={inputVariables["customField"]}
                                    onChange={handleInput}
                                    placeholder={"Custom Field"}
                                />
                            </Box>
                        </Flex>
                    }

                    <Button colorScheme="green" padding={"20px"} onClick={saveBasicJobData} isDisabled={(job?.jobStatus === JobStatus.Completed || isLoading || (jobUserData && jobUserData?.jobData?.length > 0)) || (!isEditVars)} >Save</Button>
                    <Button colorScheme="green" padding={"20px"} onClick={handleDiscard} isDisabled={(job?.jobStatus === JobStatus.Completed) || isLoading || (jobUserData && jobUserData?.jobData?.length > 0)}>{isEditVars ? "Discard" : "Edit"}</Button>
                </Flex>
                <Flex gap={"20px"} mt={"30px"} justifyContent={"center"} alignItems={"center"}>
                    <Button colorScheme="green" value={"All"} isLoading={(job?.jobStatus === JobStatus.Inprogress)} onClick={sendEmail} isDisabled={job?.jobStatus === "Completed" || isLoading || !selectedTemplate || (jobUserData && jobUserData?.jobData?.length <= 0) || (job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress))}>Send Email</Button>
                    <Button colorScheme="green" isLoading={job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress)} onClick={handleFilterModal} isDisabled={job?.jobStatus === "Completed" || isLoading || !job?.templateId || job?.jobStatus === JobStatus.Inprogress || (job.templateId && (job.templateId !== selectedTemplate?._id)) ? true : false}>Add Beneficiary</Button>
                    <Button colorScheme="green" onClick={sendEmail} display={(jobUserData?.totalFailedCount !== 0 || jobUserData.totalSuccessCount !== jobUserData.totalCount) && job?.jobStatus === "Completed" ? "block" : "none"} isDisabled={isLoading}>Resend Failed</Button>
                    <Button colorScheme="green" onClick={deleteAllBenFromJob} isDisabled={job?.jobStatus === "Completed" || isLoading || job?.jobStatus === JobStatus.Inprogress || !job?.templateId || (job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress))}>Clear Job Data</Button>
                    <Button colorScheme="green" onClick={clearInvalidEmailBens} isDisabled={job?.jobStatus === "Completed" || (jobUserData && jobUserData?.jobData?.length <= 0) || isLoading || job?.jobStatus === JobStatus.Inprogress || (job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress))}>Clear Invalid Emails</Button>
                </Flex>


                <Table variant="unstyled" mt={"30px"}>
                    <Thead>
                        <Tr>
                            <Th>SR.NO</Th>
                            <Th>BENEFICIARY NAME</Th>
                            <Th>BENEFICIARY EMAIL</Th>
                            <Th>BENEFICIARY ID</Th>
                            <Th>EMAIL STATUS</Th>
                            <Th>Remove</Th>
                            {jobUserData?.totalFailedCount !== 0 && <Th>Remark</Th>}
                        </Tr>
                    </Thead>
                    <Tbody >
                        {jobUserData &&
                            jobUserData?.jobData.map((item, index) => {
                                return (
                                    <Tr backgroundColor={checkEmailValidity(item.benEmail) ? "white" : "red.100"} key={item.benId} >
                                        <Td>{((jobUserData.limit) * ((jobUserData.page) - 1)) + index + 1}</Td>
                                        <Td>{item.benName}</Td>
                                        <Td>{item.benEmail}</Td>
                                        <Td>{item.benId}</Td>
                                        <Td>{item.status}</Td>
                                        <Td>
                                            <Flex justifyContent={"center"} >
                                                <Button onClick={() => deleteJobBen(item.benId)} isDisabled={(job?.jobStatus === "Completed" && jobUserData?.totalFailedCount === 0) || isLoading || (job?.jobStatus === JobStatus.Inprogress)} >
                                                    <MdDelete color="red" ></MdDelete>
                                                </Button>
                                            </Flex>
                                        </Td>
                                        {jobUserData?.totalFailedCount !== 0 && <Td><Text >{item.reason}</Text></Td>}
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
                <Flex
                    display={jobUserData?.jobData && jobUserData?.jobData?.length > 0 ? "flex" : "none"}
                    justifyContent={"center"}
                    gap={"20px"}
                    alignItems={"center"}
                    mt={"30px"}
                    padding={"10px"}
                >
                    {/* Previous Button */}
                    <Button
                        isLoading={isPaginationLoading}
                        onClick={() =>
                            handlePagination(
                                jobUserData?.page ? Number(jobUserData.page) - 1 : 1,
                                jobUserData?.limit ? Number(jobUserData.limit) : 10
                            )
                        }
                        colorScheme="green"
                        isDisabled={!jobUserData?.hasPreviousPage}
                    >
                        Previous
                    </Button>

                    {/* Page Dropdown */}
                    <Select
                        width={"fit-content"}
                        value={jobUserData?.page}
                        onChange={(e) =>
                            handlePagination(
                                Number(e.target.value),
                                jobUserData?.limit ? Number(jobUserData.limit) : 10
                            )
                        }
                        isDisabled={isPaginationLoading}
                    >
                        {Array.from({ length: jobUserData?.totalPages || 0 }, (_, index) => (
                            <option key={index + 1} value={index + 1}>
                                Page {index + 1} of {jobUserData?.totalPages}
                            </option>
                        ))}
                    </Select>

                    {/* Next Button */}
                    <Button
                        isLoading={isPaginationLoading}
                        colorScheme="green"
                        onClick={() =>
                            handlePagination(
                                jobUserData?.page ? Number(jobUserData.page) + 1 : 1,
                                jobUserData?.limit ? Number(jobUserData.limit) : 10
                            )
                        }
                        isDisabled={!jobUserData?.hasNextPage}
                    >
                        Next
                    </Button>

                    {/* Limit Dropdown */}
                    <Select
                        width={"fit-content"}
                        onChange={handlePageLimit}
                        isDisabled={isPaginationLoading}
                        value={jobUserData?.limit}
                    >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={300}>300</option>
                    </Select>
                </Flex>
                {benFilter && <BenFilterPopup handleCloseModal={() => handleCloseModal(setBenFilter, benFilter)} companyId={companyId}></BenFilterPopup>}
            </Box>

        </Layout >
    )
}